// Koffeinbolaget cookie consent: the engine behind snippets/kb-consent.liquid.
// Plan: research/cookie-banner-plan.md, section 4. Record: research/cookie-banner-record.md.
//
// SHOPIFY'S CUSTOMER PRIVACY API IS THE ONLY SOURCE OF TRUTH. This file never reads or
// writes a cookie, never touches storage and never makes a request of its own. It asks the
// API what the visitor decided, and it tells the API what the visitor chose. Shopify's own
// pixels follow the API by themselves.
//
// THE CONSENT STATE DECIDES, NOT THE REGION. The card shows while any of analytics,
// marketing or preferences reads '' (undecided). shouldShowBanner() is not consulted: with
// Shopify's banner removed its region answer is unreliable, and the store sells to Sweden.
//
// FAIL CLOSED. No loadFeatures, an error, no answer within 5 seconds, or a consent object
// that does not read back: the state is "unavailable", every boolean is false, and nothing
// gated on consent turns on. A save counts only when the API reads back exactly what was
// sent; an error, 8 seconds of silence or a mismatch keeps the UI and shows the error.
//
// WHAT OTHER CODE CAN READ: <html data-kb-consent> (pending from theme.liquid, then
// unresolved, resolved or unavailable), a kb:consent event on document with
// { state, analytics, marketing, preferences } as "processing allowed" booleans, and
// window.kbConsent { ready, state(), open(opener) }. kb.js section 2b gates
// "Fortsätt där du slutade" on preferences.
//
// COPY LIVES IN THE MARKUP. Every string, the errors included, is rendered by the snippet
// and only unhidden here. Inert in the theme editor, so a merchant never has to click
// through a banner to edit a section.
(function () {
  'use strict';

  // Theme previews can evaluate an asset twice, so one shared guard prevents duplicate saves.
  if (window.__kbConsentEngineLoaded) return;
  window.__kbConsentEngineLoaded = true;

  var documentRef = window.document;
  var root = null;
  var card = null;
  var panel = null;
  var toast = null;
  var saving = false;
  var inert = false;
  var opener = null;
  var focusMainAfterClose = false;
  var latestDetail = null;
  var readyResolve;
  var toastFrame = null;
  var toastOutTimer = null;
  var toastHideTimer = null;

  var ready = new Promise(function (resolve) {
    readyResolve = resolve;
  });

  window.kbConsent = {
    ready: ready,
    state: function () {
      return latestDetail;
    },
    open: function (source) {
      openPanel(source || null);
    }
  };

  function makeDetail(state, consent) {
    return {
      state: state,
      analytics: state === 'unavailable' ? false : consent.analytics === 'yes',
      marketing: state === 'unavailable' ? false : consent.marketing === 'yes',
      preferences: state === 'unavailable' ? false : consent.preferences === 'yes'
    };
  }

  function publish(state, consent) {
    var safeConsent = consent || { analytics: '', marketing: '', preferences: '' };
    latestDetail = makeDetail(state, safeConsent);
    documentRef.documentElement.setAttribute('data-kb-consent', state);
    if (readyResolve) {
      readyResolve(latestDetail);
      readyResolve = null;
    }
    documentRef.dispatchEvent(new window.CustomEvent('kb:consent', {
      detail: latestDetail
    }));
  }

  function setUnavailable() {
    if (card) card.hidden = true;
    publish('unavailable');
  }

  function readConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
    try {
      return privacy.currentVisitorConsent();
    } catch (error) {
      return null;
    }
  }

  function isConsentShape(consent) {
    return consent &&
      typeof consent.analytics === 'string' &&
      typeof consent.marketing === 'string' &&
      typeof consent.preferences === 'string';
  }

  function consentState(consent) {
    if (!isConsentShape(consent)) return null;
    // One undecided category still needs an honest choice from the visitor.
    if (consent.analytics === '' || consent.marketing === '' || consent.preferences === '') {
      return 'unresolved';
    }
    return 'resolved';
  }

  function applyConsent(consent) {
    var state = consentState(consent);
    if (!state) {
      setUnavailable();
      return;
    }
    if (card) card.hidden = state === 'resolved';
    if (!saving) setActionsUnavailable(false);
    publish(state, consent);
  }

  function setActionsUnavailable(value) {
    if (!root) return;
    var actions = root.querySelectorAll('[data-kbc-action]');
    for (var i = 0; i < actions.length; i += 1) {
      // Close is never disabled. It saves nothing, so it has nothing to wait for, and in
      // "unavailable" it is the only way out of the panel for a pointer or a thumb.
      var isClose = actions[i].getAttribute('data-kbc-action') === 'close';
      if (value && !isClose) actions[i].setAttribute('aria-disabled', 'true');
      else actions[i].removeAttribute('aria-disabled');
    }
  }

  function setSaving(value) {
    saving = value;
    setActionsUnavailable(value);
    if (!root) return;
    if (value) root.setAttribute('aria-busy', 'true');
    else root.removeAttribute('aria-busy');
  }

  function hideSaveErrors() {
    if (!root) return;
    var errors = root.querySelectorAll('[data-kbc-error="save"]');
    for (var i = 0; i < errors.length; i += 1) errors[i].hidden = true;
  }

  function showSaveError() {
    var surface = panel && panel.open ? panel : card;
    if (!surface) return;
    var error = surface.querySelector('[data-kbc-error="save"]');
    if (error) error.hidden = false;
  }

  function setSwitches(consent) {
    if (!panel) return;
    var switches = panel.querySelectorAll('[data-kbc-category]');
    for (var i = 0; i < switches.length; i += 1) {
      var category = switches[i].getAttribute('data-kbc-category');
      switches[i].checked = Boolean(consent && consent[category] === 'yes');
    }
  }

  function isVisible(element) {
    if (!element || typeof element.focus !== 'function' || element.isConnected === false) return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    if (typeof window.getComputedStyle === 'function') {
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    if (typeof element.getClientRects === 'function' && element.getClientRects().length === 0) return false;
    return true;
  }

  function focusMain() {
    var main = documentRef.getElementById('MainContent');
    if (main && typeof main.focus === 'function') main.focus({ preventScroll: true });
  }

  function restoreFocus() {
    var target = focusMainAfterClose ? null : opener;
    focusMainAfterClose = false;
    opener = null;
    if (isVisible(target)) target.focus({ preventScroll: true });
    else focusMain();
  }

  function closePanel() {
    if (panel && panel.open) panel.close();
  }

  function openPanel(source) {
    if (inert || !panel) return;
    var consent = readConsent();
    setSwitches(consent);
    hideSaveErrors();
    var unavailableError = panel.querySelector('[data-kbc-error="unavailable"]');
    var unavailable = latestDetail && latestDetail.state === 'unavailable';
    if (unavailableError) unavailableError.hidden = !unavailable;
    setActionsUnavailable(unavailable || saving);
    opener = source;
    if (!panel.open) panel.showModal();
  }

  function payloadFromSwitches() {
    var payload = { analytics: false, marketing: false, preferences: false };
    if (!panel) return payload;
    var switches = panel.querySelectorAll('[data-kbc-category]');
    for (var i = 0; i < switches.length; i += 1) {
      var category = switches[i].getAttribute('data-kbc-category');
      if (Object.prototype.hasOwnProperty.call(payload, category)) {
        payload[category] = Boolean(switches[i].checked);
      }
    }
    return payload;
  }

  function matchesPayload(consent, payload) {
    if (!isConsentShape(consent)) return false;
    var categories = ['analytics', 'marketing', 'preferences'];
    for (var i = 0; i < categories.length; i += 1) {
      var category = categories[i];
      var expected = payload[category] ? 'yes' : 'no';
      if (consent[category] !== expected) return false;
    }
    return true;
  }

  function requestFrame(callback) {
    if (typeof window.requestAnimationFrame === 'function') {
      return window.requestAnimationFrame(callback);
    }
    return window.setTimeout(callback, 0);
  }

  function cancelFrame(frame) {
    if (frame === null) return;
    if (typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(frame);
    else window.clearTimeout(frame);
  }

  function showToast() {
    if (!toast) return;
    cancelFrame(toastFrame);
    window.clearTimeout(toastOutTimer);
    window.clearTimeout(toastHideTimer);
    toast.classList.remove('is-in');
    toast.hidden = false;
    toastFrame = requestFrame(function () {
      toastFrame = null;
      toast.classList.add('is-in');
    });
    toastOutTimer = window.setTimeout(function () {
      toast.classList.remove('is-in');
      toastHideTimer = window.setTimeout(function () {
        toast.hidden = true;
      }, 200);
    }, 1500);
  }

  function saveConsent(payload) {
    if (saving) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      showSaveError();
      return;
    }

    hideSaveErrors();
    setSaving(true);
    var finished = false;
    var timer = window.setTimeout(function () {
      finishFailure();
    }, 8000);

    function finishFailure() {
      if (finished) return;
      finished = true;
      window.clearTimeout(timer);
      showSaveError();
      setSaving(false);
    }

    function finishSuccess(consent) {
      if (finished) return;
      finished = true;
      window.clearTimeout(timer);
      var savedFromPanel = Boolean(panel && panel.open);
      // A card opener is about to disappear, so returning there would strand keyboard focus.
      if (savedFromPanel && opener && card && card.contains(opener)) focusMainAfterClose = true;
      closePanel();
      if (card) card.hidden = true;
      showToast();
      publish('resolved', consent);
      setSaving(false);
      if (!savedFromPanel) focusMain();
    }

    try {
      privacy.setTrackingConsent(payload, function (error) {
        if (finished) return;
        if (error) {
          finishFailure();
          return;
        }
        var consent = readConsent();
        if (!matchesPayload(consent, payload)) {
          finishFailure();
          return;
        }
        finishSuccess(consent);
      });
    } catch (error) {
      finishFailure();
    }
  }

  function handleAction(event) {
    var action = event.target.closest('[data-kbc-action]');
    if (!action || !root.contains(action)) return;
    var name = action.getAttribute('data-kbc-action');
    // Ahead of the guards, the same as Escape: closing records nothing in any state.
    if (name === 'close') {
      closePanel();
      return;
    }
    if (action.getAttribute('aria-disabled') === 'true' || saving) return;
    if (name === 'accept-all') {
      saveConsent({ analytics: true, marketing: true, preferences: true });
    } else if (name === 'necessary-only') {
      saveConsent({ analytics: false, marketing: false, preferences: false });
    } else if (name === 'customize') {
      openPanel(action);
    } else if (name === 'save') {
      saveConsent(payloadFromSwitches());
    }
  }

  function handleOpen(event) {
    var control = event.target.closest('[data-kbc-open]');
    if (control) openPanel(control);
  }

  function handleOutsideConsent() {
    // The save callback performs its own verified read and publishes the authoritative result.
    if (saving) return;
    var consent = readConsent();
    if (!consent) {
      setUnavailable();
      return;
    }
    applyConsent(consent);
  }

  function bind() {
    root.addEventListener('click', handleAction);
    documentRef.addEventListener('click', handleOpen);
    documentRef.addEventListener('visitorConsentCollected', handleOutsideConsent);
    panel.addEventListener('cancel', function (event) {
      event.preventDefault();
      closePanel();
    });
    panel.addEventListener('close', restoreFocus);
  }

  function loadPrivacyApi() {
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') {
      setUnavailable();
      return;
    }

    var answered = false;
    var timer = window.setTimeout(function () {
      if (answered) return;
      answered = true;
      setUnavailable();
    }, 5000);

    try {
      shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1' }
      ], function (error) {
        if (answered) return;
        answered = true;
        window.clearTimeout(timer);
        if (error) {
          setUnavailable();
          return;
        }
        var consent = readConsent();
        if (!consent) {
          setUnavailable();
          return;
        }
        applyConsent(consent);
      });
    } catch (error) {
      if (answered) return;
      answered = true;
      window.clearTimeout(timer);
      setUnavailable();
    }
  }

  function boot() {
    root = documentRef.getElementById('kb-consent');
    card = root && root.querySelector('[data-kbc-card]');
    panel = root && root.querySelector('[data-kbc-prefs]');
    toast = root && root.querySelector('[data-kbc-toast]');

    if (!root || !card || !panel || window.Shopify && window.Shopify.designMode === true) {
      inert = true;
      setUnavailable();
      return;
    }

    bind();
    loadPrivacyApi();
  }

  if (documentRef.readyState === 'loading') {
    documentRef.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());
